import React, { Component } from 'react';
import './../../assets/css/App.css';
import { Tabs, Tab } from 'react-bootstrap';
import AccountWithoutSendShipmentsView from './accWithoutSentShipmentView';
import AccountWithoutReceivedPackageView from './accWithoutReceivedPackageView';
import AccountSortBySendShipmentsView from './accSortBySendShipmentsView';
import AccountSortByRevenueView from './accSortByRevenueView';
import InactiveAccountForTimePeriodView from './inactiveAccForTimePeriodView';
import ShipmentsWithCouponsView from './shipmentsWithCouplsView';
import SendShipmentsByMonthView from './sendShipmentsByMonthView';

class TabPanelView extends Component {
    state = {
        selectedTabKey: 1
    }

    constructor() {
        super();
    }

    handleTabSelect = (key) => {
        this.setState({
            selectedTabKey : key
        });
    };

    render() {
        return (
            <div>
                <Tabs activeKey={this.state.selectedTabKey} onSelect={this.handleTabSelect} id="controlled-tab-example">
                    <Tab eventKey={1} title="Accounts without sent shipments">
                        <AccountWithoutSendShipmentsView></AccountWithoutSendShipmentsView>
                    </Tab>
                    <Tab eventKey={2} title="Accounts without receiving a package">
                        <AccountWithoutReceivedPackageView></AccountWithoutReceivedPackageView>
                    </Tab>
                    <Tab eventKey={3} title="Accounts sorted by sent shipments">
                        <AccountSortBySendShipmentsView></AccountSortBySendShipmentsView>
                    </Tab>
                    <Tab eventKey={4} title="Accounts sorted by revenue">
                        <AccountSortByRevenueView></AccountSortByRevenueView>
                    </Tab>
                    <Tab eventKey={5} title="Incative Accounts for Period">
                        <InactiveAccountForTimePeriodView></InactiveAccountForTimePeriodView>
                    </Tab>
                    <Tab eventKey={6} title="Shipments With Coupons">
                        <ShipmentsWithCouponsView></ShipmentsWithCouponsView>
                    </Tab>
                    <Tab eventKey={7} title="Sent Shipments by Month">
                        <SendShipmentsByMonthView></SendShipmentsByMonthView>
                    </Tab>
                </Tabs>
            </div>
        );
    }
}

export default TabPanelView;